import React from 'react';
import { Button } from '../ui/button';

const EmptyState = ({
  emptyComponent,
  title = '',
  description = '',
  buttonTitle = '',
  renderButton = true,
  ...rest
}: {
  emptyComponent?: React.ReactNode;
  title?: string;
  description?: string;
  buttonTitle?: string;
  renderButton?: boolean;
  onClick?: () => void;
}) => {
  return (
    <div className="flex justify-center w-full py-10">
      <div className="max-w-3xl space-y-6">
        {emptyComponent}
        <div className="text-center">
          <h3 className="text-2xl text-gray-800">{title}</h3>
          <p className="text-lg text-gray-600">{description}</p>
        </div>
        {!!renderButton && (
          <div className="flex justify-center w-full">
            <Button onClick={rest.onClick}>{buttonTitle}</Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default EmptyState;
